<!-- 赛程管理 -->
<template>
    <div>
        <event-head @match-Type="getMatchType"></event-head>
        <div class="top-area" style="display: flex;align-items: center;">
            <div style="flex: 1;color: #fff;">
                <span>选择日期:</span>
                <el-date-picker v-model="pageInfo.day" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                    style="margin-left: 20px;" @change="changeDate">
                </el-date-picker>
            </div>
            <div class="changeMatch">
                <el-dropdown  @command="handleMatch">
                    <span style="font-size: 13px;color: #ececec;">
                        一键生成赛程<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" >
                        <div v-for="item in typeList" :key="item.typeId">
                            <el-dropdown-item :command="item">{{ item.typeName }}</el-dropdown-item>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <el-button class="add_btn" type="primary" @click="addMatch">新增</el-button>
        </div>
        <div class="mt-3">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="{
                color: '#fff',
                fontSize: '14px',
                height: '40px',
                width: '100%',
            }">
                <el-table-column type="index" label="序号" align="center" width="60">
                </el-table-column>
                <el-table-column prop="round" label="轮次名称" align="center"></el-table-column>
                <el-table-column prop="matchTimeInfo" label="时间" align="center"></el-table-column>
                <el-table-column prop="formatType" label="赛程类型" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.formatType == 1">小组赛</span>
                        <span v-if="scope.row.formatType == 2">淘汰赛</span>
                        <span v-if="scope.row.formatType == 0">--</span>
                    </template>
                </el-table-column>
                <el-table-column prop="homeTeamName" label="主队" align="center"></el-table-column>
                <el-table-column prop="homeTeamShirt" label="主队球衣" align="center"></el-table-column>
                <el-table-column prop="awayTeamName" label="客队" align="center"></el-table-column>
                <el-table-column prop="awayTeamShirt" label="客队球衣" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="editScore(scope.row)">修改积分</el-button>
                        <el-button type="text" @click="editCourse(scope.row)">修改</el-button>
                        <el-button type="text" @click="deleteCourse(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination layout="total, prev, pager, next" :current-page="pageInfo.page"
            :page-size="pageInfo.pageSize" :total="pageInfo.count"
            @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        </div>
        <el-dialog :visible.sync="dialogVisibleMatch" title="修改" width="60%" @close="closeDialog">
            <el-form ref="form" :model="form" label-width="120px" class="infoForm" :rules="rule">
                <div class="group-name">
                    <div class="group"></div>
                    <div class="name">基本信息</div>
                </div>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="开赛日期" prop="matchDate">
                            <el-date-picker value-format="yyyy-MM-dd" v-model="form.matchDate" type="date"
                                placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="开赛时间" prop="beginTime">
                            <el-time-picker value-format="HH:mm:ss" @blur="$forceUpdate()" v-model="form.beginTime"
                                :picker-options="{
                                    selectableRange: '00:00:00 - 23:30:00'
                                }" placeholder="选择时间点">
                            </el-time-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="承办球场" prop="stadium">
                            <div style="display: flex;align-items: center;">
                                <el-input v-model="form.stadium" placeholder="请选择承办球场" :disabled="true"></el-input>
                                <el-button type="primary" style="margin-left: 10px" @click="changePosition">地图选点</el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="场地名称" prop="venue">
                            <el-input v-model="form.venue" placeholder="请输入场地名称"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="轮次名称" prop="round">
                            <el-input v-model="form.round" placeholder="请输入轮次名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="裁判姓名">
                            <el-select v-model="form.refereeId" v-if="this.matchInfo.matchType == 2">
                                <el-option v-for="item in refereeList" :key="item.refereeId" :label="item.realName"
                                    :value="item.refereeId"></el-option>
                                            <el-pagination layout="total, prev, pager, next" :current-page="pageInfo.page"
                                                :page-size="pageInfo.pageSize" :total="pageInfo.count"
                                                 @size-change="handleSizeChange" @current-change="handleCurrentChange">
                                            </el-pagination>
                            </el-select>
                            <el-input v-model="form.referee" v-else></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="比赛用球">
                            <el-input v-model="form.matchBall" placeholder="请输入比赛用球"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="赛程类型" prop="formatType">
                            <el-select v-model="form.formatType">
                                <el-option v-for="item in courseType" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="group-name">
                    <div class="group"></div>
                    <div class="name">球队信息</div>
                </div>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="主队组别">
                            <el-select v-model="form.teamGroupId" @change="changeTeamGroupName">
                                <el-option v-for="item in teamGroup" :key="item.teamGroupId" :label="item.teamGroupName"
                                    :value="item.teamGroupId"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="主队选择" prop="homeTeamName">
                            <el-select v-model="form.homeTeamName" @change="homeTeamChange">
                                <el-option v-for="item in homeTeamList" :key="item.teamId" :label="item.teamName"
                                    :value="item.teamName"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="主队球衣颜色" prop="homeTeamShirt">
                            <el-select v-model="form.homeTeamShirt" placeholder="请选择主队球衣颜色">
                                <el-option v-for="item in Jersey" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="客队组别">
                            <el-select v-model="form.awayGroupId" @change="changeAwayTeamGroup">
                                <el-option v-for="item in teamGroup" :key="item.teamGroupId" :label="item.teamGroupName"
                                    :value="item.teamGroupId"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="客队选择" prop="awayTeamName">
                            <el-select v-model="form.awayTeamName" @change="awayTeamChange">
                                <el-option v-for="item in awayTeamList" :key="item.teamId" :label="item.teamName"
                                    :value="item.teamName"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="客队球衣颜色" prop="awayTeamShirt">
                            <el-select v-model="form.awayTeamShirt" placeholder="请选择客队球衣颜色">
                                <el-option v-for="item in Jersey" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleMatch = false">取 消</el-button>
                <el-button type="primary" @click="commitMatch">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 地图弹窗 -->
        <el-dialog :visible.sync="showMapDialog" v-if="showMapDialog" title="地图选点">
            <Map @map-submit="mapSubmit" :address="form.stadiu"></Map>
        </el-dialog>
        <!-- 修改积分 -->
        <el-dialog :visible.sync="dialogVisibleScore" title="修改积分" width="60%" @close="closeDialog" >
            <el-form ref="scoreData" :model="scoreData" label-width="120px" class="infoForm" :rules="rule">
                <div class="group-name">
                    <div class="group"></div>
                    <div class="name">{{scoreData.round}}</div>
                </div>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="主队">
                            <el-input v-model="scoreData.homeTeamName" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="客队">
                            <el-input v-model="scoreData.awayTeamName" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="队伍选择" prop="matchTeamId">
                            <el-select v-model="scoreData.matchTeamId">
                                <el-option v-for="item in scoreTeamList" :key="item.matchTeamId" :label="item.typeName"
                                    :value="item.matchTeamId"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="修改积分">
                            <el-input v-model="scoreData.addScore" placeholder="请输入" type="number"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="备注" prop="remark">
                            <el-input v-model="scoreData.remark" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleScore = false">取 消</el-button>
                <el-button type="primary" @click="commitScore">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Map from '@/views/eventManage/components/Map';
import EventHead from '@/common/components/eventHead/EventHead';
export default {
    components: {
        Map, EventHead
    },
    data() {
        return {
            refereeList: [],
            pageInfo: {
                page: 1,
                pageSize: 10,
                day: "",
                count: 0,
            },
            refereePage: {
                page: 1,
                pageSize: 10,
                personNo: "",
                realName: ""
            },
            dialogVisibleMatch: false,
            dialogVisibleScore: false,
            showMapDialog: false,
            formData: {},
            tableData: [],
            scoreData:{
                homeTeamName:"",
                awayTeamName:"",
                round:"",
                addScore:"",
                remark:"",
                matchId:"",
                matchScheduleId:"",
                matchTeamId:""
            },
            eventOption: [{
                value: 0,
                label: '红牌'
            },
            {
                value: 1,
                label: '黄牌'
            },
            {
                value: 2,
                label: '进球'
            },
            {
                value: 3,
                label: '助攻'
            },
            {
                value: 4,
                label: '乌龙球'
            },
            {
                value: 5,
                label: '点球'
            }],
            Jersey: [
                {
                    value: "暂无",
                    label: "暂无"
                },
                {
                    value: "蓝白",
                    label: "蓝白"
                },
                {
                    value: "白色",
                    label: "白色"
                },
                {
                    value: "粉色",
                    label: "粉色"
                },
                {
                    value: "曼城蓝",
                    label: "曼城蓝"
                },
                {
                    value: "白藏蓝",
                    label: "白藏蓝"
                },
                {
                    value: "红色",
                    label: "红色"
                },
                {
                    value: "橙色",
                    label: "橙色"
                },
                {
                    value: "黄色",
                    label: "黄色"
                },
                {
                    value: "绿色",
                    label: "绿色"
                },
                {
                    value: "绿白",
                    label: "绿白"
                },
                {
                    value: "黄蓝",
                    label: "黄蓝"
                },
                {
                    value: "蓝色",
                    label: "蓝色"
                },
                {
                    value: "黑色",
                    label: "黑色"
                },
                {
                    value: "紫色",
                    label: "紫色"
                }],
            form: {
                teamGroupId: '',
                awayGroupId: ''
            },
            courseType: [
                {
                    value: 1,
                    label: "小组赛",
                },
                {
                    value: 2,
                    label: "淘汰赛",
                }],
            recordData: [{}],
            homeTeamData: [],
            title: "",
            matchInfo: {},
            homeTeamList: [],
            awayTeamList: [],
            teamGroup: [],
            stepOneForm: {},
            stepThreeForm: {},
            stepFourForm: {},
            matchType: '',
            changeHomeTeam: true,
            changeAwayTeam: true,
            rule: {
                matchDate: [{ required: true, message: '请选择', trigger: 'change' }],
                beginTime: [{ required: true, message: '请选择', trigger: 'change' }],
                stadium: [{ required: true, message: '请选择承办球场', trigger: 'change' }],
                venue: [{ required: true, message: '请输入场地名称', trigger: 'blur' }],
                round: [{ required: true, message: '请输入', trigger: 'blur' }],
                homeTeamName: [{ required: true, message: '请选择', trigger: 'change' }],
                awayTeamName: [{ required: true, message: '请选择', trigger: 'change' }],
                addScore: [{ required: true, message: '请输入', trigger: 'change' },
                { pattern:/^[1-9]\d*$/, message: '请输入正确数字', trigger: 'blur' }
                ],
                remark: [{ required: true, message: '请输入', trigger: 'change' }],
                matchTeamId: [{ required: true, message: '请选择', trigger: 'change' }],

            },
            typeList: [
                {
                    typeName: "单循环",
                    typeId: 1
                },
                {
                    typeName: "双循环",
                    typeId: 2
                }
            ],
            scoreTeamList: []
        };
    },
    mounted() {
        if (localStorage.getItem('matchId')) {
            this.matchInfo = localStorage.getItem('currentMatchId') ? JSON.parse(localStorage.getItem('currentMatchId')) : {};
            this.getMatchScheduleList()
            this.getTeamGroupList();
            this.getMatchDetail();
            this.getTeamList();
            this.getRefereeList();
            this.getAwayTeamList();
        } else {
            this.$confirm('暂无赛事！！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
        }
    },
    methods: {
        // 获取赛程
        async getMatchScheduleList() {
            const params = {
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize,
                day: this.pageInfo.day
            };
            const { res } = await this.$http.get(`/Match/MatchScheduleList/${this.matchInfo.matchId}`, { params });
            this.tableData = res.data.list || [];
            this.pageInfo.count = res.data.total;
            this.tableData.map(item => {
                item.matchTimeInfo = item.matchDate==null?item.matchDate:item.matchDate.slice(0, 10) + item.matchTime==null?item.matchTime:item.matchTime.slice(10, 20)
            })
            
        },
        // 获取裁判
        async getRefereeList() {
            const { res } = await this.$http.get(`/Match/RefereeList/${this.matchInfo.matchId}`);
            this.refereeList = res.data.list || [];
            this.refereePage.count = res.data.total;
        },
        // 获取赛制类型
        getMatchType(match) {
            this.matchType = match;
            // console.log(1111, this.matchType)
        },
        // 选择日期
        changeDate() {
            this.getMatchScheduleList()
        },
        // 选择位置
        changePosition() {
            this.showMapDialog = true
        },
        // 获取位置
        mapSubmit(location, address) {
            console.log(111, location);
            this.form.stadium = address;
            this.form.longitude = location.lng;
            this.form.latitude = location.lat;
            this.showMapDialog = false;
        },
        // 获取赛事信息
        async getMatchDetail() {
            const { res } = await this.$http.get(`/Match/MatchInfo/${this.matchInfo.matchId}`);
            this.stepOneForm = res.data.info;
            this.stepThreeForm = res.data.formatInfo;
            this.stepFourForm = res.data.extInfo;
        },
        // 获取组别
        async getTeamGroupList() {
            const { res } = await this.$http.get(`/Match/TeamGroupList/${this.matchInfo.matchId}`);
            this.teamGroup = res.data || [];
            this.teamGroup.push({ teamGroupId: 0, teamGroupName: '暂无分组' })
        },
        // 选择主队组别
        changeTeamGroupName(val) {
            this.form.teamGroupName = this.teamGroup.find(teamGroup => {
                return teamGroup.teamGroupId === val;
            }).teamGroupName;
            this.form.teamGroupId = val
            this.getTeamList();
        },
        // 选择客队组别
        changeAwayTeamGroup(val) {
            this.form.awayGroupId = val
            this.getAwayTeamList();
        },
        // 获取主队球队
        async getTeamList() {
            if (this.form.teamGroupId == '') {
                this.teamGroupId = 0
            } else {
                this.teamGroupId = this.form.teamGroupId
            }
            const { res } = await this.$http.get(`/Match/MatchTeamList/${this.matchInfo.matchId}/${this.teamGroupId}`);
            if (res.isSuccess) {
                this.homeTeamList = res.data || [];
                this.homeTeamList.push({ teamId: 0, teamName: '待定' })
            }

        },
        // 获取客队球队
        async getAwayTeamList() {
            if (this.form.awayGroupId == '') {
                this.awayGroupId = 0
            } else {
                this.awayGroupId = this.form.awayGroupId
            }
            const { res } = await this.$http.get(`/Match/MatchTeamList/${this.matchInfo.matchId}/${this.awayGroupId}`);
            if (res.isSuccess) {
                this.awayTeamList = res.data || [];
                this.awayTeamList.push({ teamId: 0, teamName: '待定' })
            }

        },
        //选择主队
        homeTeamChange(val) {
            this.form.homeTeamId = this.homeTeamList.find(team => {
                return team.teamName === val;
            }).teamId;
        },
        //选择客队
        awayTeamChange(val) {
            this.form.awayTeamId = this.awayTeamList.find(team => {
                return team.teamName === val;
            }).teamId;
            // console.log(11111, this.form.awayTeamId)
        },
        // 保存赛程
        commitMatch() {
            if (this.form.teamGroupId == '') {
                this.form.teamGroupId = 0
            }
            this.form.matchId = this.matchInfo.matchId
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$confirm('请核实信息，确定要发布改赛程吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }).then(async () => {
                        const { res } = await this.$http.post('/Match/SaveMatchSchedule', this.form);
                        if (res.isSuccess) {
                            this.$showSuccess('发布成功');
                            this.dialogVisibleMatch = false
                            this.getMatchScheduleList();
                        }
                    });
                } else {
                    this.$message.error("请填写完整信息！");
                    return
                }
            })

        },
        // 新增赛程
        addMatch() {
            this.dialogVisibleMatch = true
            this.form.beginTime = '12:00:00';
            this.form.stadium = this.stepOneForm.stadiumAddress
            this.form.latitude = this.stepOneForm.latitude
            this.form.longitude = this.stepOneForm.longitude
            this.title = "新增赛程"
        },
        // 关闭弹窗
        closeDialog() {
            this.dialogVisibleMatch = false;
            this.title = '';
            this.form = {};
            this.course = []
        },
        // 删除赛程
        deleteCourse(row) {
            const matchScheduleId = row.matchScheduleId
            this.$confirm('确认要删除该赛事吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(async () => {
                const { res } = await this.$http.post(`/Match/DeleteMatchSchedule/${this.matchInfo.matchId}/${matchScheduleId}`);
                if (res.isSuccess) {
                    this.$showSuccess('删除成功');
                    this.getMatchScheduleList();
                } else {
                    this.$showError(res.msg)
                }
            });
        },
        // 修改赛事
        editCourse(row) {
            this.dialogVisibleMatch = true
            this.form = this.cloneDeep(row);
            if (this.form.matchDate !== null) {
                this.form.matchDate = this.form.matchDate.slice(0, 10);
            }
            if (this.form.beginTime !== null) {
                this.form.beginTime = this.form.matchTime.slice(11, 20)
            }
            this.form.awayGroupId = 0
            this.title = "修改赛事"
        },
        //修改积分弹窗
        async editScore(rowScore){
            this.scoreTeamList = [];
            const selectData = {};
            selectData.typeName = '主队';
            selectData.matchTeamId = rowScore.homeTeamId;
            this.scoreTeamList.push(selectData);
            const selectData1 = {};
            selectData1.typeName = '客队';
            selectData1.matchTeamId = rowScore.awayTeamId;
            this.scoreTeamList.push(selectData1);
            
            console.log(this.scoreTeamList);
            console.log(rowScore);
            this.scoreData.homeTeamName = (rowScore.homeTeamName || "");
            this.scoreData.homeTeamId = (rowScore.homeTeamId || "");
            this.scoreData.awayTeamId = (rowScore.awayTeamId || "");
            this.scoreData.awayTeamName = (rowScore.awayTeamName || "");
            this.scoreData.round = (rowScore.round || "");
            this.scoreData.addScore = "";
            this.scoreData.remark = "";
            this.scoreData.matchId = (rowScore.matchId || "");
            this.scoreData.matchScheduleId = (rowScore.matchScheduleId || "");
            this.scoreData.matchTeamId = (rowScore.matchTeamId || "");
            this.dialogVisibleScore = true;
        },
        commitScore(){
            console.log(this.scoreData);
            this.$refs.scoreData.validate((valid) => {
                if (valid) {
                    this.$confirm('请核实信息，确定要修改积分吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }).then(async () => {
                        const { res } = await this.$http.post('/Match/SaveScheduleAddScore', this.scoreData);
                        if (res.isSuccess) {
                            this.$showSuccess('修改成功');
                            this.dialogVisibleScore = false
                        }
                    });
                } else {
                    this.$message.error("请填写完整信息！");
                    return
                }
            })
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.getMatchScheduleList();
        },
        handleCurrentChange(val) {
            this.pageInfo.page = val;
            this.getMatchScheduleList();
        },
        // 下拉框分页
        handleRefereeChange(val) {
            this.refereePage.pageSize = val;
            this.getRefereeList();
        },
        handleCurrentReferee(val) {
            this.refereePage.page = val;
            this.getRefereeList();
        },
        // 一键生成赛程
        handleMatch(item) {
            this.scheduleCircleType=item.typeId
            this.$confirm('确认要一键生成赛程吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(async () => {
                const { res } = await this.$http.get(`/Match/AutoSchedule/${this.matchInfo.matchId}/${this.scheduleCircleType}`);
                if (res.isSuccess) {
                    this.$showSuccess('一键生成赛程成功');
                    this.getMatchScheduleList();
                } else {
                    this.$showError(res.msg)
                }
            });
        },
        // 深拷贝
        cloneDeep(target) {
            // 传入null，还是返回null
            if (target === null) {
                return target;
            }
            // 判断是否是对象
            if (typeof target === 'object') {
                // 兼容数组与对象
                let obj = Array.isArray(target) ? [] : {};
                for (let key in target) {
                    obj[key] = this.cloneDeep(target[key]);
                }
                return obj;
            } else {
                return target;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
/deep/.el-input--small .el-input__inner {
    color: #e9e9e9;
}

.add {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 0 10px;
    background-color: #fff;
    border-bottom: 1px solid #a5a1a1;
}

.line {
    height: 20px;
    width: 7px;
    background-color: #000;
    border-radius: 10px;
}

.title {
    font-size: 18px;
    display: flex;
    align-items: center;
}

.group-name {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .group {
        width: 5px;
        height: 18px;
        background-color: #2ba245;
        border-radius: 2px;
    }

    .name {
        margin-left: 10px;
        font-weight: 600;
        font-size: 18px;
    }
}

.top-area {
    display: flex;
    align-items: center;
    margin-top: 20px;
}

.changeMatch {
    width: 120px;
    height: 30px;
    margin-right: 20px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background-image: linear-gradient(270deg, #00d6ea 0%, #0e6ae9 100%);
}

.add_btn {
    display: flex;
    justify-content: flex-end;
}</style>